// ProfileInfoRow.jsx

const ProfileInfoRow = ({ label, value, actions }) => {
  return (
    <div className="space-y-1">
      <p className="text-[14px] md:text-[16px] font-semibold">{label}</p>
      <div className="flex justify-between items-center w-full p-[6px] rounded-[10px] border-neutral-30 border-[1px] min-h-[40px]">
        <p className="text-[14px] md:text-[16px] text-[#999999]">{value}</p>
        {actions && <div className="flex items-center gap-1">{actions}</div>}
      </div>
    </div>
  );
};

export default ProfileInfoRow;
